module.exports = __webpack_public_path__ + "img/fonepay_logo.9b5a9f41.jpg";